import fetchClient, { ApiResponse } from '@/api/api-client'

import { CurrencyRate } from './types/CurrencyRate'

export const getCurrencyRates = async (): Promise<CurrencyRate> => {
  const res = await fetchClient.get('/dollarCurrency')
  return res.data.data?.[0]
}

export const updateCurrencyObj = async (body: CurrencyRate) => {
  try {
    const dollarCurrencyObjectID = '271963cc-e16b-4bfa-bdcb-d24199914b0f'
    const res = await fetchClient.patch<ApiResponse<{ response: { Attributes: CurrencyRate } }>>(
      `/dollarCurrency/${dollarCurrencyObjectID}`,
      body
    )
    return res.data.data.response.Attributes
  } catch (error) {
    console.log('updateCurrencyObj - error', error)
  }
}
